import React, { useContext, useState, useEffect } from "react";
import { Flex } from "@src/components/Boxes";
import styled from "@emotion/styled";
import Link from "@src/components/UTMLink";
import Translate from "@src/components/translation/Translate";
import { CloseIcon } from "@src/components/nessie-web";
import { getRelativePath } from "@src/utils/routes";
import { mediaQueries } from "@src/styles/theme";
import Container from "@src/components/Container";
import { TranslationContext } from "@src/components/translation/TranslationContext";
import { logEvent } from "@src/utils/logClient";
import UTMLink from "@src/components/UTMLink";

const Header = styled("h2")`
  font-size: 16px;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.14);
  color: #fff;
  line-height: 1.1;
  font-weight: 200;
  z-index: 3;
  text-align: center;
  margin-bottom: 0;
  margin-top: 0px;
  ${mediaQueries[1]} {
    font-size: 24px;
  }
`;
const CloseButton = styled.button`
  width: 40px;
  height: 40px;
  color: #fff;
  font-size: 24px;
  z-index: 999;
  transition: opacity 0.4s;
  background: transparent;
  outline: 0;
  border: 0;
  cursor: pointer;
  ${mediaQueries[1]} {
    font-size: 40px;
    width: 55px;
    height: 55px;
  }
`;

type SchoolClosureBannerSectionProps = {
  closeFunction: () => void;
};

const SchoolClosureBannerSection: React.FC<SchoolClosureBannerSectionProps> = ({ closeFunction }) => {
  const t = useContext(TranslationContext);

  return (
    <Flex
      padding="12px"
      position="relative"
      justifyContent="center"
      alignItems="center"
      backgroundColor={"#00aeef"}
      width="100%"
      overflow="hidden"
      height="60px"
    >
      <Container>
        <Link
          to={getRelativePath("/districts?utm_source=homepageBanner")}
          onClick={() => {
            logEvent("web.external.blueBanner.click");
            closeFunction();
          }}
        >
          <Header>
            Introducing ClassDojo for Districts ✨ <u>Discover more</u>
          </Header>
        </Link>
      </Container>
      <CloseButton aria-label={t.translate("layouts.main.close")?.toString() ?? ""} onClick={() => closeFunction()}>
        <CloseIcon color="dt_white" />
      </CloseButton>
    </Flex>
  );
};

export default SchoolClosureBannerSection;
